"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var UIUtils_1 = require("../../../shared/modules/UIUtils");
var BaseController_1 = require("../../../shared/controllers/BaseController");
var webAApi_1 = require("../../api/webAApi");
var moment = require("moment");
var AdminsAccessBrandsCtl = /** @class */ (function (_super) {
    __extends(AdminsAccessBrandsCtl, _super);
    function AdminsAccessBrandsCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_obtain_admin_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.obtain_admin_login; });
        _this.dk_grant_admin_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.grant_admin_login; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this._errDialog = errDialog;
        return _this;
    }
    AdminsAccessBrandsCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: [],
        };
    };
    AdminsAccessBrandsCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    AdminsAccessBrandsCtl.prototype.LoadDataByBrandId = function (brandId, onDone) {
        var _this = this;
        webAApi_1.ListAdminAccessByBrandGet.exec({ brand_id: brandId }, function (resp) {
            _this.DATA.data = [];
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    obtain_admin_login: resp.list[i].obtain_admin_login,
                    grant_admin_login: resp.list[i].grant_admin_login,
                    brand_title: resp.list[i].brand_title,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AdminsAccessBrandsCtl.prototype.LoadDataByObtainAdminId = function (adminId, onDone) {
        var _this = this;
        webAApi_1.ListAllowedBrandsByObtainAdminIdGet.exec({ obtain_usr_admin_id: adminId }, function (resp) {
            _this.DATA.data = [];
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    grant_admin_login: resp.list[i].grant_admin_login,
                    obtain_admin_login: resp.list[i].obtain_admin_login,
                    brand_title: resp.list[i].brand_title,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AdminsAccessBrandsCtl.prototype.LoadDataByGrantAdminId = function (adminId, onDone) {
        var _this = this;
        webAApi_1.ListAllowedBrandsByGrantAdminIdGet.exec({ grant_usr_admin_id: adminId }, function (resp) {
            _this.DATA.data = [];
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    grant_admin_login: resp.list[i].grant_admin_login,
                    obtain_admin_login: resp.list[i].obtain_admin_login,
                    brand_title: resp.list[i].brand_title,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AdminsAccessBrandsCtl.prototype.DoAddAccess = function (brandId, adminId, onDone) {
        var _this = this;
        webAApi_1.DoAddBrandAdminAccess.exec({
            data: {
                brand_id: brandId,
                usr_admin_id: adminId
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                grant_admin_login: resp.grant_admin_login,
                obtain_admin_login: resp.obtain_admin_login,
                brand_title: resp.brand_title,
                date_added: moment(resp.date_added_uts_ms).utc(false)
            });
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AdminsAccessBrandsCtl.prototype.RemoveItem = function (brandAccessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === brandAccessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    AdminsAccessBrandsCtl.prototype.DoDeleteAccess = function (brandAccessKey, onDone) {
        var _this = this;
        var _tmp = this.getById(brandAccessKey);
        if (_tmp) {
            webAApi_1.DoDeleteBrandAdminAccess.exec({ data: { brand_admin_access_id: brandAccessKey } }, function (resp) {
                _this.RemoveItem(brandAccessKey);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return AdminsAccessBrandsCtl;
}(BaseController_1.BaseController));
exports.AdminsAccessBrandsCtl = AdminsAccessBrandsCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/shared/controllers/AdminsAccessBrandsCtl.ts
// module id = 2159
// module chunks = 0